//
//
//
//
export default {
  name: "editPass",
  data: function data() {
    return {};
  },
  components: {},
  computed: {},
  methods: {},
  mounted: function mounted() {}
};